import { AuthProvider } from "@jarvis/web-data-collection";
import { Configuration, ConfigurationProvider } from "../JWeb/types";
import { getStratusStack } from "./utils";
import { getDataCollectionService } from "../JWeb";
import { AnalyticsServiceInputType } from "./types";
import ConsentService from "../consentService/ConsentService";
import bindAllMethods from "../../utils/bindAllMethods";
import { Stack } from "../JWeb/JWebEnums";

export type DataCollectionServiceConfigProps = {
  stack: string;
  authProvider: AuthProvider | any;
  telemetryAPIkey?: string | any;
  valveControllerAPIkey?: string | any;
  logging?: boolean;
};

export class DataCollectionRecorderNative {
  public async init(): Promise<void> {
    // No-operation Class
  }
  public async updateDataCollectionService(): Promise<void> {
    // No-operation Class
  }
  public async setInterfaceDependencies(): Promise<void> {
    // No-operation Class
  }
}

/// Only for Web
export class DataCollectionRecorderWeb {
  private _stack: string;
  private _telemetryAPIkey: string | any;
  private _valveControllerAPIkey: string | any;
  private _authProvider?: AuthProvider | null;
  private _consentService!: ConsentService;
  private _dataCollectionServicePlugin: any;
  private _logging: boolean;

  constructor(analyticsProps: AnalyticsServiceInputType) {
    const {
      stack,
      telemetryAPIkey,
      valveControllerAPIkey,
      authProvider,
      logging,
    } = analyticsProps;

    this._stack = Stack[stack];
    this._telemetryAPIkey = telemetryAPIkey;
    this._valveControllerAPIkey = valveControllerAPIkey;
    this._authProvider = authProvider;
    this._logging = logging ?? true;
  }

  public async init(consentService: ConsentService): Promise<void> {
    this._consentService = consentService;
    bindAllMethods(this);
  }

  private getDataCollectionServiceConfig({
    authProvider,
    stack,
    telemetryAPIkey,
    valveControllerAPIkey,
    logging,
  }: DataCollectionServiceConfigProps): Configuration {
    return {
      stack: getStratusStack(stack),
      authProvider: authProvider,
      telemetryAPIkey: telemetryAPIkey,
      valveControllerAPIkey: valveControllerAPIkey,

      verboseLogging: logging, //set to true to see console messages
      useValveControllerFiltering: false, //set to true for filtering using ValveControllerAPI
      useOneTrustFiltering: true,
      preConsentEventAccumulation: true,
      isBatchingEnabled: false,
    };
  }

  public async updateDataCollectionService(): Promise<void> {
    this._dataCollectionServicePlugin = await getDataCollectionService();
    // to keep up-to-date the consent in value store
    await this._consentService?.updateOptInGroupsInValueStore();

    // Configure DataCollection Provider
    const dataCollectionServiceConfig: Configuration =
      this.getDataCollectionServiceConfig({
        stack: this._stack,
        authProvider: this._authProvider,
        telemetryAPIkey: this._telemetryAPIkey,
        valveControllerAPIkey: this._valveControllerAPIkey,
        logging: this._logging,
      });

    const configurationProvider: ConfigurationProvider = {
      configuration: dataCollectionServiceConfig,
    };

    this._dataCollectionServicePlugin?.setConfigurationProvider(
      configurationProvider
    );
  }
}
